<template>
	<pre v-html="$t('terms.privacy_policy2')"></pre>
</template>

<script>
export default {
	name: 'PrivacyPolicy2',
};
</script>

<style scoped></style>
